module.exports = __webpack_public_path__ + "static/media/release.fcbb35d0.png";